module.exports = __webpack_public_path__ + "static/media/img_patient_refuse.be9552cf.svg";